export enum WatermarkPosition {
  None = 'none',
  Center = 'center', // display at center rotated at 20°.
  CenterNotRotated = 'center-not-rotated', // display at center without rotating
  CenterText = 'center-text', // display text from watermarkPosition at center rotated at 20°.
  CenterTextNotRotated = 'center-text-not-rotated', // display text from watermarkPosition at center without rotating
  Left = 'left',
  Right = 'right',
  GroundEdges = 'ground-edges', // display on ground 4 times around the building.
}
